import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';

import Head from '../../components/dashHeader/dashHeader';
import Nav from '../../components/comDashboard/dashNavigation/dashNavigation';

import Estadisticas from '../../components/comDashboard/dashEstadisticas/estaHome';
import Historial from '../../components/comDashboard/dashHistorial/historialHome';
import Consumo from '../../components/comDashboard/dashConsumo/consumoHome';
import {connect} from 'react-redux';

class Dashboard extends Component {

    constructor(props){
        super(props);
        this.state = {
            user:null
        }
    }

    verificarRuta = (Componente) => {

        if(this.props.user) //verifico que tenga iniciado a un usuario
            return <Componente />; //le permito ver el componente que me solicita
        else
            return <Redirect to="/admin" />; //si no ha iniciado lo redirijo al login
    }
    
    render(){
        return(
            <div className='contenedorDashboard'>
                <Head />
                <div className='row'>
                    <Nav/>
                    <Route path="/admin/dashboard/Estadisticas" render={() => this.verificarRuta(Estadisticas)} />
                    <Route path="/admin/dashboard/Historial" render={() => this.verificarRuta(Historial)} />
                    <Route path="/admin/dashboard/Consumo" render={() => this.verificarRuta(Consumo)} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state)=>({
    user:state.user
})

export default connect(mapStateToProps, null)(Dashboard);